import { render, staticRenderFns } from "./rp-roles-tip.vue?vue&type=template&id=ac55d110"
import script from "./rp-roles-tip.vue?vue&type=script&lang=js"
export * from "./rp-roles-tip.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-tip.vue?vue&type=style&index=0&id=ac55d110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports